/**
 * @author      sam@zumper.com (Sam Sherman)
 * @copyright   Copyright (c) 2019, Zumper
 * @description detail whitelist
 */

import { buildingReviewsWhitelist } from '@zcode-ui/web-zumper-features'
import { SET_MOBILE } from '@zcode-ui/web-zumper-global-state'
import * as constants from '../constants'
import { default as cancellationWhitelist } from '../modules/cancellation/reducers/whitelist'
import { default as entityWhitelist } from '../modules/entity/reducers/whitelist'
import { whitelist as lifestylesWhitelist } from '../modules/lifestyles/whitelist'
import { whitelist as mlsDataWhitelist } from '../modules/mlsData/reducers/whitelist'
import { whitelist as monetizedSimilarListingsWhitelist } from '../modules/monetizedSimilarListings/reducers/whitelist'
import { whitelist as nearbyWhitelist } from '../modules/nearby/reducers/whitelist'
import { whitelist as prosConsWhiteList } from '../modules/proConData/reducers/whitelist'
import { whitelist as ratingsWhiteList } from '../modules/ratings/reducers/whitelist'
import { whitelist as unitsWhitelist } from '../modules/units/reducers/whitelist'
import type { ActionTypes } from './types'

export const whitelist = [
  SET_MOBILE,
  ...Object.values(constants),
  ...entityWhitelist,
  ...lifestylesWhitelist,
  ...mlsDataWhitelist,
  ...monetizedSimilarListingsWhitelist,
  ...nearbyWhitelist,
  ...unitsWhitelist,
  ...cancellationWhitelist,
  ...prosConsWhiteList,
  ...buildingReviewsWhitelist,
  ...ratingsWhiteList,
  // This satisfies makes sure that everything in the whitelist is also used in the reducer
] as const satisfies ReadonlyArray<ActionTypes['type']>

// These 2 lines make sure that every action type that the reducer uses is included in the whitelist
declare const shouldBeEmpty: Exclude<ActionTypes['type'], (typeof whitelist)[number]>
false && (shouldBeEmpty satisfies never)

export default whitelist
